import React, { useContext, useLayoutEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { History, Location } from 'history';
import { Row, Col, Button, Modal, message, Select } from 'antd';
import i18n from 'i18next';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { FaCaretDown } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { getUserState } from '../../store/user/selector';

import { NotificationDropdown } from './component/NotificationFeed';
import { AccountTypeContext } from '../dashboard/Dashboard';

import Logo from '../../assets/images/logo-horizontal-colored.png';
import Eng from '../../assets/images/uk_flag.png';
import Cz from '../../assets/images/cz_flag.png';
import Itl from '../../assets/images/it_flag.png';
// import UserIcon from '../../assets/images/png/nav/user.png';
// import HatIcon from '../../assets/images/png/nav/hat.png';
// import ListIcon from '../../assets/images/png/nav/list.png';
// import ChatIcon from '../../assets/images/png/nav/chat.png';
// import ForkIcon from '../../assets/images/png/nav/fork.png';

import USERICON from '../../assets/images/png/user.png';

import UserIconActive from '../../assets/images/png/nav/new/user.png';
import HatIconActive from '../../assets/images/png/nav/new/hat.png';
import ForkIconActive from '../../assets/images/png/nav/new/fork.png';
import ListIconActive from '../../assets/images/png/nav/new/list.png';
import ChatIconActive from '../../assets/images/png/nav/new/chat.png';
import { logoutuser } from '../../store/user/actions';
import { changeAccountType } from '../../store/settings/actions';
import { BellBadge } from '../notification/component/BellBadge';
const COOK = 'cook';
// const GUEST = 'guest';
const COOKS = 'Cook';
const GUEST = 'Guest';
export interface NavigationParmams {
  icon: string;
  onClick?: (e?: React.MouseEvent) => void;
  isPathName: boolean;
}

export interface ModalButtonParams {
  title: string;
  onClick?: (e?: React.MouseEvent) => void;
}

export interface ModalProps {
  onCreateAccountPress: (e?: React.MouseEvent) => void;
  onLoginAccountPress: (e?: React.MouseEvent) => void;
  onPressCancel: (e?: React.MouseEvent) => void;
}

const HeaderIcons: React.FC<NavigationParmams> = ({
  icon,
  onClick,
  isPathName,
}) => (
  <Button type="link" block onClick={onClick}>
    <div className="header-icon-btn">
      <img src={icon} alt={icon} className={!isPathName ? 'icon-styles' : ''} />
    </div>
  </Button>
);

export const ModalButtons: React.FC<ModalButtonParams> = ({
  title,
  onClick,
}) => {
  return (
    <Button
      block
      type="primary"
      shape="round"
      onClick={onClick}
      className="continue-button continue-button-primary"
    >
      <span className="continue-button-text">{title}</span>
    </Button>
  );
};

export const AuthModalContent: React.FC<ModalProps> = ({
  onCreateAccountPress,
  onLoginAccountPress,
  onPressCancel,
}) => {
  return (
    <div className="modal-content-wrapper">
      <div className="modal-content-icon">
        <img src={USERICON} alt="modal-content-icon" />
      </div>
      <div className="modal-content-description">
        <span>{i18n.t('LOGIN_MODAL')}</span>
      </div>

      <div className="button-container">
        <div className="modal-content-extra">{i18n.t('TAKE_A_MOMENT')}</div>
        <ModalButtons
          title={i18n.t('CREATE_AN_ACCOUNT')}
          onClick={onCreateAccountPress}
        />
        <ModalButtons title={i18n.t('LOGIN')} onClick={onLoginAccountPress} />
        <Button
          block
          shape="round"
          onClick={onPressCancel}
          className="cancel-button cancel-button-primary"
        >
          <span className="continue-button-text">{i18n.t('Cancel')}</span>
        </Button>
      </div>
    </div>
  );
};

export const Navbar: React.FC = () => {
  const { forWho } = useContext(AccountTypeContext);
  const { t } = useTranslation();
  const [language, setLanguage] = useState<string>(i18next.language);
  const history: History = useHistory();
  const location: Location = useLocation();
  const dispatch = useDispatch();
  const { user } = useSelector(getUserState);
  const isAuth = user.userid !== '';
  const handleCancelPress = () => {
    Modal.destroyAll();
  };
  const handleLinkClick = (link: string) => (): void => {
    history.push(link);

    setTimeout(() => {
      Modal.destroyAll();
    }, 500);
  };

  const restrictionModalConfig = {
    icon: null,
    false: true,
    maskClosable: true,
    className: 'modal-content-container modal-content-description',
    okButtonProps: { style: { display: 'none' } },
    content: (
      <AuthModalContent
        onCreateAccountPress={handleLinkClick(
          `/authentication/registration/${forWho}`
        )}
        onLoginAccountPress={handleLinkClick(
          `/authentication/login/email/${forWho}`
        )}
        onPressCancel={handleCancelPress}
      />
    ),
  };

  const handleSwitchAccountType = () => {
    if (window.confirm('Are you sure you want to switch account?')) {
      dispatch(changeAccountType());
    }
  };

  const handleChangeAccountType = () => {
    const userState = {
      accountType: user.accountType === 'cook' ? 'guest' : 'cook',
      address: user.address,
      authComplete: user.authComplete,
      description: user.description,
      email: user.email,
      firstName: user.firstName,
      image: user.image,
      lastName: user.lastName,
      phone: user.phone,
      status: user.status,
      userid: user.userid,
      username: user.username,
    };
    if (
      window.confirm(
        `Are you sure you want to become a ${
          user.accountType === 'cook' ? 'Guest?' : 'Cook?'
        }`
      )
    ) {
      history.push({
        pathname: '/profile/update',
        state: userState,
      });
    }
  };

  const handleNavLinkClick = (link: string) => (): void => {
    if (user.userid) {
      history.push(link);
      return;
    }
    Modal.info(restrictionModalConfig);
  };

  const onPressLogout = () => {
    dispatch(logoutuser());
    message.info('Logged out');
    history.push('/dashboard');
  };

  const handleTranslation = (value: string) => {
    setLanguage(value);
    document.location.reload();
    i18next.changeLanguage(value);
  };

  const USER = UserIconActive;
  const HAT = HatIconActive;
  const FORK = ForkIconActive;
  const ORDERS = ListIconActive;
  const CHAT = ChatIconActive;

  const [windowWidth, setWindowWidth] = useState(0);

  const isDesktop = windowWidth >= 768;
  useLayoutEffect(() => {
    const updateSize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.addEventListener('resize', updateSize);
  }, []);
  const isPathname =
    location.pathname === '/dashboard' ||
    location.pathname === '/mealdetails' ||
    location.pathname === '/mymeals' ||
    location.pathname === '/orders' ||
    location.pathname === '/orderdetails' ||
    location.pathname === '/chat';
  return !isDesktop ? (
    <Col xs={24} sm={24} md={14} lg={10} xl={10}>
      <Row className="menu-header">
        <Col>
          <HeaderIcons
            icon={USER}
            onClick={handleNavLinkClick('profile')}
            isPathName={location.pathname === '/profile'}
          />
        </Col>
        <Col>
          {user.accountType === COOK ? (
            <HeaderIcons
              icon={HAT}
              onClick={handleNavLinkClick('/mymeals')}
              isPathName={location.pathname === '/mymeals'}
            />
          ) : (
            <HeaderIcons
              icon={FORK}
              onClick={handleNavLinkClick('/dashboard')}
              isPathName={
                location.pathname === '/dashboard' ||
                location.pathname === '/mealdetails'
              }
            />
          )}
        </Col>
        <Col>
          <HeaderIcons
            icon={ORDERS}
            onClick={handleNavLinkClick('/orders')}
            isPathName={
              location.pathname === '/orders' ||
              location.pathname === '/ordersdetails'
            }
          />
        </Col>
        <Col>
          <HeaderIcons
            icon={CHAT}
            onClick={handleNavLinkClick('/chat')}
            isPathName={location.pathname === '/chat'}
          />
        </Col>
        {user.userid && <BellBadge />}
      </Row>
    </Col>
  ) : (
    <Col span={24} className="page-header-header-container">
      <Row className="page-header with-space">
        <Col className="header-logo">
          <img src={Logo} alt="mca-logo" />
        </Col>
        <Col className="header-icons-block">
          {isAuth &&
            (!isPathname ? (
              <Col className="primary-button-basic-container header-button">
                {user.subAccountType === '' ||
                user.subAccountType === undefined ? (
                  <Button
                    type="primary"
                    shape="round"
                    className="primary-button-basic profile-button"
                    onClick={handleChangeAccountType}
                  >
                    {t(
                      `Became a ${user.accountType === COOK ? 'Guest' : 'Cook'}`
                    )}
                  </Button>
                ) : (
                  <Select
                    value={user.accountType === 'cook' ? COOKS : GUEST}
                    style={{
                      width: 140,
                      height: 36,
                      borderRadius: 9,
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    suffixIcon={<FaCaretDown />}
                    onChange={
                      user.subAccountType === ''
                        ? handleChangeAccountType
                        : handleSwitchAccountType
                    }
                  >
                    <Select.Option value={GUEST}>
                      {t('I_AM_GUEST')}
                    </Select.Option>
                    <Select.Option value={COOKS}>
                      {t('I_AM_COOK')}
                    </Select.Option>
                  </Select>
                )}
              </Col>
            ) : null)}
          <Col className="header-icons">
            <Col>
              {user.accountType === COOK ? (
                <HeaderIcons
                  icon={HAT}
                  onClick={handleNavLinkClick('/mymeals')}
                  isPathName={location.pathname === '/mymeals'}
                />
              ) : (
                <HeaderIcons
                  icon={FORK}
                  onClick={handleNavLinkClick('/dashboard')}
                  isPathName={
                    location.pathname === '/dashboard' ||
                    location.pathname === '/mealdetails'
                  }
                />
              )}
            </Col>
            <Col>
              <HeaderIcons
                icon={ORDERS}
                onClick={handleNavLinkClick('/orders')}
                isPathName={
                  location.pathname === '/orders' ||
                  location.pathname === '/orderdetails'
                }
              />
            </Col>
            <Col>
              <HeaderIcons
                icon={CHAT}
                onClick={handleNavLinkClick('/chat')}
                isPathName={location.pathname === '/chat'}
              />
            </Col>
            <Col>
              <HeaderIcons
                icon={USER}
                onClick={handleNavLinkClick('profile')}
                isPathName={location.pathname === '/profile'}
              />
            </Col>
          </Col>

          {isAuth && <NotificationDropdown />}

          {isAuth &&
            (!isPathname ? (
              <Col className="header-authenticated">
                <span className="active">{user.firstName}</span>
                <span className="divider" />
                <Button type="link" onClick={onPressLogout}>
                  {t('Logout')}
                </Button>
              </Col>
            ) : null)}
          <div className="header-logo">
            <Select
              defaultValue="en"
              onChange={handleTranslation}
              value={language}
            >
              <Select.Option value="en">
                <img
                  src={Eng}
                  alt="mca-english"
                  style={{ width: '35px', marginRight: '10px' }}
                />
                {'EN'}
              </Select.Option>
              <Select.Option value="cz">
                <img
                  src={Cz}
                  alt="mca-czech"
                  style={{ width: '35px', marginRight: '10px' }}
                />
                {'CZ'}
              </Select.Option>
              <Select.Option value="it">
                <img
                  src={Itl}
                  alt="mca-italian"
                  style={{ width: '35px', marginRight: '10px' }}
                />
                {'IT'}
              </Select.Option>
            </Select>
          </div>
        </Col>
      </Row>
    </Col>
  );
};
